import { apiClient } from "@lib/apiClient";

// Media (call recordings + MMS attachments) live behind the API's signed proxy.
// The raw Twilio URLs require auth, so we exchange them for short-lived signed
// URLs on the API origin that can be used directly as <audio>/<img> sources.
export type SignMediaBody =
  | { kind: "recording"; callId: string }
  | { kind: "messageMedia"; messageId: string; index: number };

/**
 * Ask the API to mint a short-lived signed URL for a piece of media.
 * The returned URL is usable directly as an <audio src> / <img src> — no
 * Authorization header needed. Throws ApiError on failure so callers can
 * hide the player/thumbnail gracefully.
 */
export async function signMedia(body: SignMediaBody): Promise<string> {
  const { url } = await apiClient.post<{ url: string }>("/media/sign", body);
  return url;
}
